const state = {
  listaUnidadesProcedencia: undefined
}

export default state
